import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { ErrorList, InputLabelWrapper, } from '@guildeducationinc/recess';
import { Autocomplete, Chip, CircularProgress, TextField } from '@mui/material';
import classNames from 'classnames';
import { compact, uniqueId } from 'lodash';
import { useLocale } from '../../hooks';
import styles from './MuiMultiSelect.module.scss';
export const MuiMultiSelect = ({ label, hideLabel, placeholder, value, onChange, options, className, errors, disabled, additionalInfo, helpText, required, onSearch, onScrollEnd, loading, inputValue, paginationLoading = false, disablePortal = false, }) => {
    const { t } = useLocale();
    const inputId = uniqueId('select-input-');
    const handleSelect = (_, selections) => {
        const values = selections.map(s => s.value);
        // Trigger onChange event
        onChange({
            target: { value: values },
            selection: selections,
        });
    };
    const getOpt = (value) => {
        return options.find(opt => opt.value === value);
    };
    // Enhance options with loading indicator if paginating
    const enhancedOptions = [...options];
    if (paginationLoading) {
        enhancedOptions.push({
            value: '__loading__',
            label: 'Loading...',
            isLoadingIndicator: true,
        });
    }
    const customRenderOption = (props, option) => {
        if (option.isLoadingIndicator) {
            return (_createElement("li", { ...props, key: 'loading-indicator', style: { ...props.style, pointerEvents: 'none' } },
                _jsx(CircularProgress, { size: 20 }),
                _jsx("span", { style: { marginLeft: 8 }, children: t('Loading more options...') })));
        }
        return (_createElement("li", { ...props, key: option.value }, option.label));
    };
    return (_jsxs("div", { className: classNames(className, 'flex flex-col gap-2'), children: [label && (_jsx(InputLabelWrapper, { hideLabel: hideLabel, label: label, inputId: inputId, additionalInfo: additionalInfo, required: required, helpText: helpText })), _jsx("div", { className: 'flex', children: _jsx(Autocomplete, { multiple: true, className: styles.select, value: compact((value || []).map(v => getOpt(v))), onChange: handleSelect, options: enhancedOptions, getOptionLabel: option => option.label || '', disabled: disabled, disableClearable: true, disableCloseOnSelect: true, disablePortal: disablePortal, loading: loading, ListboxProps: {
                        onScroll: event => {
                            const listboxNode = event.currentTarget;
                            if (onScrollEnd &&
                                !paginationLoading && // Don't trigger if already loading
                                listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 10) {
                                onScrollEnd();
                            }
                        },
                    }, onInputChange: (_, value, reason) => {
                        if (onSearch && reason === 'input') {
                            onSearch(value);
                        }
                    }, renderTags: (tagValue, getTagProps) => tagValue.map((option, index) => {
                        const { key, onDelete, disabled, ...tagProps } = getTagProps({ index });
                        return (_jsx(Chip, { label: option.displayText || option.label, onDelete: disabled ? undefined : onDelete, disabled: false, ...tagProps }, key));
                    }), renderInput: params => (_jsx(TextField, { placeholder: (value || []).length > 0 ? undefined : placeholder, ...params, InputProps: {
                            ...params.InputProps,
                            endAdornment: (_jsxs(_Fragment, { children: [loading ? (_jsx("span", { className: styles.spinner, children: _jsx(CircularProgress, { color: 'inherit', size: 20 }) })) : null, params.InputProps.endAdornment] })),
                        } })), noOptionsText: t('No options available'), inputValue: inputValue, renderOption: customRenderOption }) }), _jsx(ErrorList, { show: !!errors, errors: errors })] }));
};
